import React from "react";
import { useGlobalContext } from "./context/globalContext";
import "../index.css";

const AboutDeveloper = ({ project }) => {
  const { handleShowModal } = useGlobalContext();
  return (
    <section className="section shadow-sm lazyloaded" id="developer">
      {/* <div className="d-block pt-2 pb-1 text-center">
        <img
          src="images/dosti-logo.webp"
          width="auto"
          height="100%"
          loading="lazy"
          alt="Dosti Realty"
        />
      </div> */}
      <div className="row">
        <div className="col-md-8">
          <h1 class="d-block section-heading color-primary text-capitalize">
            About Developer
          </h1>
        </div>
        <div className="col-md-4">
          <button
            className="btn btn-info micro-form-btn enqModal effetMoveGradient effectScale download_brochure float-lg-right d-none d-lg-block"
            onClick={handleShowModal}
          >
            Chat with us
          </button>
        </div>
      </div>

      <p>
        With a legacy spanning 40+ years, Dosti Realty has developed 127+
        residential and commercial projects across Mumbai, Pune, and Thane.
        Known for premium quality, timely delivery, and innovative designs, the
        company has established itself as a leader in luxury real estate. Dosti
        Greenscapes is their latest landmark development, bringing elite living,
        contemporary architecture, and top-tier amenities to Pune’s Upper Camp
        region. <br />
        <strong>Trust. Excellence. Legacy. Welcome to Dosti Realty.</strong>
      </p>

      <div class="rera-numbers">
        <div class="rera-item">
          <img src="images/dostiGreenscapesRera1.webp" alt="rera qr" />
          <strong>P52100049942</strong>
        </div>
        <div class="rera-item">
          <img src="images/dostiGreenscapesRera2.webp" alt="rera qr" />
          <strong>P52100051041</strong>
        </div>
        <div class="rera-item">
          <img src="images/dostiGreenscapesRera3.webp" alt="rera qr" />
          <strong>P52100077059</strong>
        </div>
        <div class="rera-item">
          <img src="images/dostiGreenscapesRera4.webp" alt="rera qr" />
          <strong>P52100077092</strong>
        </div>
      </div>

      <span className="pro-rera text-center-mob">
        {project} has been registered via MahaRERA registration number and is
        available on the website{" "}
        <a href="https://maharera.mahaonline.gov.in/">
          https://maharera.mahaonline.gov.in/
        </a>{" "}
        under registered projects.
      </span>

      <button
        className="btn btn-info micro-form-btn enqModal effetMoveGradient effectScale download_brochure float-lg-right mx-sm-auto d-lg-none"
        data-form="lg"
        data-title=" Chat with us"
        data-btn=" Chat with us"
        data-enquiry="Download Brochure Left Panel"
        data-redirect="enquiry"
        data-toggle="modal"
        data-target="#enqModal"
        onClick={handleShowModal}
      >
        Chat with us
      </button>
    </section>
  );
};

export default AboutDeveloper;
